import { render } from "./IdentityVerification.vue?vue&type=template&id=4e6f616c&scoped=true"
import script from "./IdentityVerification.vue?vue&type=script&lang=js"
export * from "./IdentityVerification.vue?vue&type=script&lang=js"

import "./IdentityVerification.vue?vue&type=style&index=0&id=4e6f616c&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6f616c"]])

export default __exports__